import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Link,
  Typography,
} from '@mui/material'
import { FC } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { createSelector } from 'reselect'
import { clearTemplateDeleteErrorTemplateId } from 'src/state/ducks/templateList/actions'
import { RootState } from 'src/state/store'

const selectTemplateName = (templateId: number | undefined) =>
  createSelector(
    (state: RootState) => state.templateListState.templates,
    templates => {
      if (!templateId) {
        return ''
      }
      return templates.find(template => template.id === templateId)?.name
    },
  )

/**
 * 削除時のエラーモーダル表示用のコンポーネント
 * @returns
 */
export const DeleteErrorModal: FC = () => {
  const dispatch = useDispatch()

  const templateDeleteErrorTemplateId = useSelector(
    (state: RootState) => state.templateListState.templateDeleteErrorTemplateId,
  )
  const templateName = useSelector(
    selectTemplateName(templateDeleteErrorTemplateId),
  )

  const handleClose = () => dispatch(clearTemplateDeleteErrorTemplateId())

  return (
    <Dialog
      open={!!templateDeleteErrorTemplateId}
      onClose={handleClose}
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle>「{templateName}」の削除が出来ません</DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ mt: 1 }}>
          取り込み項目データがすでに登録されていたので削除できません。
        </Typography>
        <Link
          href={`/gridVariables/${templateDeleteErrorTemplateId}/edit`}
          target="_blank"
          rel="noopener noreferrer"
          underline="always"
          sx={{ display: 'inline-flex', alignItems: 'center', mt: 1 }}
        >
          {`「${templateName}」の取り込み項目`}
          <OpenInNewIcon
            sx={{ fontSize: 12, ml: 0.5, verticalAlign: 'super' }}
          />
        </Link>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={handleClose}>
          閉じる
        </Button>
      </DialogActions>
    </Dialog>
  )
}
